import { Suspense, useCallback, useState } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { MobileSidebar } from "./MobileSidebar";
import { TopBar } from "./TopBar";
import { GradientSpinner } from "../common/GradientSpinner";
import { useNotificationSSE } from "../../hooks/useNotificationSSE";
import { FeedbackFAB } from "../feedback/FeedbackFAB";
import { ChatSocketProvider } from "../../contexts/ChatSocketProvider";
import { PersistentChatPanel } from "../chat/PersistentChatPanel";
import { RequirePermission } from "../common/RequirePermission";
import { Permissions } from "../../types/permissions";

export function AppLayout() {
  useNotificationSSE();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const handleMobileSidebarClose = useCallback(() => {
    setMobileSidebarOpen(false);
  }, []);

  const handleMobileMenuOpen = useCallback(() => {
    setMobileSidebarOpen(true);
  }, []);

  return (
    <ChatSocketProvider>
      <div className="flex h-screen bg-bg-page">
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((prev) => !prev)}
        />
        <MobileSidebar
          open={mobileSidebarOpen}
          onClose={handleMobileSidebarClose}
        />
        <div className="flex flex-1 flex-col overflow-hidden">
          <TopBar onMobileMenuOpen={handleMobileMenuOpen} />
          <main className="flex flex-1 flex-col overflow-hidden">
            <Suspense
              fallback={
                <div
                  className="flex h-full items-center justify-center"
                  role="status"
                >
                  <GradientSpinner size={32} />
                  <span className="sr-only">Loading page</span>
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </main>
        </div>
        <RequirePermission permission={Permissions.AI_CHAT}>
          <PersistentChatPanel />
        </RequirePermission>
        <FeedbackFAB />
      </div>
    </ChatSocketProvider>
  );
}
